import { skipToken } from '@reduxjs/toolkit/query';
import {
  ModeEnum,
  useSecuritiesContext,
  useSyncedRef,
  type Customer,
  type CustomerSpecificSecurity,
} from '@talos/kyoko';
import { useMemo } from 'react';
import { of } from 'rxjs';
import { useGetCustomerSecuritiesQuery } from '../../../../providers/AppStateProvider/streamingDataSlice';

export function useCustomerPriceGridSource(customer?: Customer) {
  const { securitiesBySymbol } = useSecuritiesContext();
  const securitiesBySymbolRef = useSyncedRef(securitiesBySymbol);

  const customerSecuritiesRequest = customer
    ? {
        Counterparty: customer.Name,
        tag: 'CustomerPriceGrid/useGetCustomerSecuritiesQuery',
      }
    : skipToken;
  const { data: customerSecuritiesBySymbol } = useGetCustomerSecuritiesQuery(customerSecuritiesRequest);

  const sourceItems = useMemo(
    () =>
      customerSecuritiesBySymbol
        ? [...customerSecuritiesBySymbol.values()]
            .filter(({ Mode, Symbol }) => Mode === ModeEnum.Enabled && !!Symbol)
            .map((customerSecurity: CustomerSpecificSecurity) => ({
              security: {
                ...securitiesBySymbolRef.current.get(customerSecurity.Symbol),
                ...customerSecurity,
              },
            }))
        : [],
    [customerSecuritiesBySymbol, securitiesBySymbolRef]
  );

  const sourceObservable = useMemo(() => of({ initial: true, data: sourceItems }), [sourceItems]);

  return useMemo(
    () => ({
      sourceItems,
      sourceObservable,
    }),
    [sourceItems, sourceObservable]
  );
}
